import type { ImagePixelSize, RatioOption } from "./generationConfig";

/**
 * 全能编辑 V3 比例扩展集（HP-9668）
 *
 * V3 实际路由渠道为 kie(GPT Image 2) 与 RunningHub（HP-9950 收窄口径，开朋/HiAPI 清单
 * 不再作为前端口径）。两渠道各清晰度档位的比例并集完全一致，为基础集之外的 5 个比例
 * （产品文档 auto 对应前端 `smart`，已在基础集中）：
 *   9:21（kie 1K / RH 全档）、2:1、1:2（kie 全档）、3:1、1:3（kie 1K / RH 全档）
 * 8:5/5:8 仅开朋 2K 支持、kie/RH 均无，已从并集移除（HP-9950）
 *
 * 约束：
 * - 追加在 {@link V3_RATIO_OPTIONS} 基础集之后展示，新比例在网格末尾聚成一排
 * - 企业专线（GptImage2Enterprise）不消费本扩展集：其尺寸表为服务端 16 倍数对齐约束，
 *   新比例需后端先补尺寸常量才能开放
 * - 扩图（OutpaintPanel）4K 白名单沿用基础集口径，不受本扩展影响
 */

/** V3 扩展比例选项（5 项，追加在 V3_RATIO_OPTIONS 基础集之后） */
export const V3_EXTENDED_RATIO_OPTIONS: RatioOption[] = [
  { value: "9:21", label: "9:21", iconWidth: 9, iconHeight: 20 },
  { value: "2:1", label: "2:1", iconWidth: 20, iconHeight: 10 },
  { value: "1:2", label: "1:2", iconWidth: 10, iconHeight: 20 },
  { value: "3:1", label: "3:1", iconWidth: 20, iconHeight: 7 },
  { value: "1:3", label: "1:3", iconWidth: 7, iconHeight: 20 }
];

/**
 * V3 扩展比例的长边适配像素表（长边 1K=1024 / 2K=2048 / 4K=4096，短边四舍五入取整）
 * 合入 V3_NORMALIZED_RATIO_QUALITY_PIXELS 后供 V3 / V3.5 提交 size 使用
 */
export const V3_EXTENDED_RATIO_PIXELS: Record<string, Record<string, ImagePixelSize>> = {
  "9:21": {
    "1K": { width: 439, height: 1024 },
    "2K": { width: 878, height: 2048 },
    "4K": { width: 1755, height: 4096 }
  },
  "2:1": {
    "1K": { width: 1024, height: 512 },
    "2K": { width: 2048, height: 1024 },
    "4K": { width: 4096, height: 2048 }
  },
  "1:2": {
    "1K": { width: 512, height: 1024 },
    "2K": { width: 1024, height: 2048 },
    "4K": { width: 2048, height: 4096 }
  },
  "3:1": {
    "1K": { width: 1024, height: 341 },
    "2K": { width: 2048, height: 683 },
    "4K": { width: 4096, height: 1365 }
  },
  "1:3": {
    "1K": { width: 341, height: 1024 },
    "2K": { width: 683, height: 2048 },
    "4K": { width: 1365, height: 4096 }
  }
};
